<template>
  <label :class="{ error: error }">
    {{ title }}
    <span v-if="!!note" class="field-note">
      {{ note }}
    </span>
  </label>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    note: {
      type: String,
      default: () => '',
    },
    error: {
      type: Boolean,
      default: () => false,
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'stylesheets/global';

label {
  color: $black;
  display: block;
  /* stylelint-disable-next-line declaration-no-important */
  font-size: 1em !important;
  font-weight: 700;
  margin: 0;
  /* stylelint-disable-next-line declaration-no-important */
  margin-bottom: 0.75rem !important;
  text-transform: none;

  &.error {
    color: #db2828;
  }

  @include sp {
    margin-bottom: 0.5rem;
  }

  .field-note {
    color: #999;
    font-weight: 400;
  }
}
</style>
